import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const CartNavLinkDefaultProps = {
  ...ClassNameDefaultProps,
  ...ChildrenDefaultProps,
};

export const CartNavLinkPropTypes = {
  ...ClassNamePropTypes,
  ...ChildrenPropTypes,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
